export function injectPathParams(path: string, params: Record<string, string>) {
  return Object.keys(params).reduce((pathWithParams, key) => {
    return pathWithParams.replace(`:${key}`, params[key]);
  }, path);
}
